module.exports = __webpack_public_path__ + "img/icon.c04865e9.png";